/**
 * Light blog post list (no article bodies) for the blog list, landing and
 * coming-soon pages — built at build time by vite-plugin-blog-index.ts.
 * The full posts (src/lib/blogPosts.ts) load only on the article page.
 */
import { BLOG_INDEX } from 'virtual:blog-index';
import type { BlogLang } from './blogLangs';

export interface BlogPostSummary {
  slug: string;
  title: string;
  description: string;
  date: string;
  lastReviewed?: string;
  readTime: number;
  category: string;
  categoryColor: string;
  coverImage: string;
  coverImageAlt: string;
  author: { name: string };
}

const byLang = BLOG_INDEX as unknown as Partial<Record<BlogLang, BlogPostSummary[]>>;

/** Posts of one language, newest first (same order as getAllPostsByLang). */
export function getPostSummariesByLang(lang: BlogLang): BlogPostSummary[] {
  const bySlug = new Map<string, BlogPostSummary>();
  for (const post of byLang[lang] ?? []) bySlug.set(post.slug, post);
  return [...bySlug.values()].sort((a, b) => b.date.localeCompare(a.date));
}
